export const VF_UPLOAD_ENUM = {
  icon: 'icon',
  text: "text",
  prj: 2,
  knowledge: 1,
  local: 3,
  simple: "simple",
  // 提资区
  TIZI: '1630981803194',
  // 成品区
  PROOFR: '1630981811371',
  // 设计区
  DESIGN: '1630981681702',
  OVER_WRITE: 'override',
  RENAME: 'rename'
};
